<template>
    <modal name="duplicate">
        <h1 class="text-xl font-bold mb-8" :class="[!companion ? 'light-blue' : 'green']">Potential Duplicate Patient</h1>
        <p class="mb-4">{{language.duplicate_warning[language_id] }}</p>
        <p class="mb-4">{{language.warning_contact[language_id]}}</p>
        <p><a :class="[!isCompanion ? 'light-blue' : 'green']"
          :href="isCompanion ? 'mailto:support@companion.health' : 'mailto:support@connectionsapp.com'">{{ isCompanion ? 'support@companion.health' : 'support@connectionsapp.com' }}</a></p>
        <button class="w-24" @click="closeModal" :class="{compbutton: companion}">{{ language.close[language_id] }}</button>
        <p></p>
    </modal>
</template>

  <script>

    import { translations } from '../../translations'

  
  export default {
    name: 'DuplicateWarningModal',
    props: {
        companion: Boolean,
        language_id: Number
    },
    data() {
        return{
            language: translations()
        }
    },
    created() { /* Called synchronously after the instance is created */ },
    mounted() { /* Called after the instance has been mounted */ },
    methods: { // component functions
      closeModal() {
        this.$modal.hide('duplicate');
      }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    button {
      height: 40px;
      font-size: 14px;
      color: #fff;
      border: none;
      padding: 6px 12px;
      border-radius: 40px;
      background: #750097;
    }

    .compbutton {
  background: #2c6759;
}
      button.send {
        border-radius: 4px;
      }
    .light-blue {
      color: #750097;
    }
    .green{
      color:#2c6759;
    }
    input {
      font-size: 14px;
      font-weight: 400;
      color: #333;
      height: 40px;
      border-radius: 4px;
      padding: 6px 12px;
      line-height: 1.42857143;
      border: 1px solid #ccc;
      -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
      box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
      -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
      -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
      transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    }
      input:focus {
        border-color: #750097;
        outline: 0;
        -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
        box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
      }
  </style>
  
  <!-- Not "scoped" to style modal -->
  <style>
    .vm--container {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .vm--overlay {
      background: rgba(8, 17, 53, 0.38) !important;
    }
    .vm--modal {
      text-align: center;
      border-radius: 4px !important;
      background: #ffffff;
      padding: 20px;
      height: auto !important;
      width: auto !important;
      max-width: 600px;
      top: auto !important;
      left: auto !important;
    }
  </style>